import { IsAccessTokenValidQuery } from '../generated/hooks';
import Overview from './Overview';

type User = IsAccessTokenValidQuery['isAccessTokenValid']['user'];
interface IProps {
  user: User;
}

const OverviewPage = (props: IProps) => {
  if (!props.user?.respondents) {
    return null;
  }

  return <Overview respondents={props.user?.respondents} baseUrl="/overview" user={props.user} />;
};

export default OverviewPage;
